import { useIntl } from 'react-intl';

import { ampli } from '../../../../core/Tracking/Amplitude/__AUTO_GENERATED__';
import { TrackingProperties } from '../../../../core/Tracking/Amplitude/Amplitude';
import { Destination } from '../../../../resources/destination/domain/types/destination';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { LogoRailEurope } from '../../illustration/LogoRailEurope';

import { TransportCard } from './TransportCard';

type RailEuropeTransportCardProps = {
    destination: PickDomain<Destination, 'id' | 'slug'>;
    trackingInformation: {
        transportSearchClicked: Pick<
            TrackingProperties<typeof ampli.transportSearchClicked>,
            'block'
        >;
    };
    railEuropeUrl: string;
    className?: string;
    isCompact?: boolean;
};

export function RailEuropeTransportCard({
    destination,
    trackingInformation,
    className,
    railEuropeUrl,
    isCompact = false,
}: RailEuropeTransportCardProps) {
    const { formatMessage } = useIntl();

    return (
        <TransportCard
            className={className}
            recommended
            isCompact={isCompact}
            title={formatMessage({
                id: isCompact
                    ? 'global.component.transports.train.shortTitle'
                    : 'global.component.transports.train.title',
            })}
            subtitle={formatMessage({
                id: 'global.component.transports.train.subtitle',
            })}
            description={formatMessage({
                id: 'global.component.transports.train.description',
            })}
            linkUrl={railEuropeUrl}
            linkLabel={formatMessage({
                id: 'global.component.transports.train.link',
            })}
            Logo={LogoRailEurope}
            trackingInformation={{
                transportSearchClicked: {
                    ...trackingInformation.transportSearchClicked,
                    destination_id: destination.id,
                    destination_slug: destination.slug,
                    transport_type: 'train',
                },
            }}
        />
    );
}
